<script lang="ts">
    import {_} from 'svelte-i18n'

    export let locale: string;
</script>

<span>{$_(`commons.language.${locale}`)}</span>
